const analyticsresult = [
  {
    size: "",
    style: "",
    class: "",
    children: [
      {
        type: "topbar",
        size: "12",
        style: "",
        class: "px-4",
        title: "General",
      },
      {
        type: "tabs",
        size: "9",
        style: "",
        class: "pr-4",
        children: [
          {
            title: "General",
            service: "category",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: false,
              activeToggle: false,
              deleteButton: false,
              updateSuccessTitle: "Category Updated!",
              updateSuccessMessage: "Category Updated Successfully!",
              updateErrorTitle: "Category Updation Failed!",
              updateErrorMessage: "Please try again!",
            },
            children: [
              {
                type: "onlineServicesTab",
                size: "12",
                style: "",
                class: "p-0",
                list: {
                  type: "list",
                  size: "4",
                  style: "",
                  class: "p-2",
                  empty: true,
                  children: [],
                },
                form: {
                  type: "form",
                  variant: "patch",
                  size: "8",
                  style: "min-height: calc(100vh - 144px)",
                  class: "pl-3 pt-3",
                  form: {
                    practice_name: {
                      type: "text",
                      label: "Practice Name",
                      placeholder: "Enter Practice Name",
                      required: true,
                      info: true,
                      character_count: 50,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    hr5: {
                      type: "hr",
                      size: "12",
                    },
                    tagline: {
                      type: "toggle",
                      label: "Tagline",
                      placeholder: "",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    tagline_name: {
                      type: "text",
                      label: " ",
                      placeholder: "Tagline",
                      required: false,
                      displayOn: "tagline",
                      displayOnValue: "true",
                      info: false,
                      character_count: 50,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    hr1: {
                      type: "hr",
                      size: "12",
                    },
                    practice_logo: {
                      type: "toggle",
                      label: "Practice Logo",
                      placeholder: "",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    formSection1: {
                      components: {
                        logo_url: {
                          type: "imgSelect",
                          label: "",
                          placeholder: "Select Image",

                          load_url: "",
                          required: false,
                          info: false,
                          character_count: 0,
                          disabled: false,
                          class: "",
                          size: "6",
                          style: "",
                        },
                      },
                      class: "",
                      size: "12",
                      style: "",
                      type: "formSection",
                      displayOn: "practice_logo",
                      displayOnValue: "true",
                    },
                    hr2: {
                      type: "hr",
                      size: "12",
                    },
                    nhs_logo: {
                      type: "toggle",
                      label: "NHS Logo",
                      placeholder: "",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "3",
                      style: "",
                    },
                    feedback_widget: {
                      type: "toggle",
                      label: "Feedback Widget",
                      placeholder: "",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "3",
                      style: "",
                    },
                    search: {
                      type: "toggle",
                      label: "Search",
                      placeholder: "",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "3",
                      style: "",
                    },
                    accessibility_widget: {
                      type: "toggle",
                      label: "Accessibility Widget",
                      placeholder: "",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "3",
                      style: "",
                    },
                    hr3: {
                      type: "hr",
                      size: "12",
                    },
                    contact: {
                      type: "toggle",
                      label: "Contacts",
                      placeholder: "",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    contact_input: {
                      type: "contactinput",
                      label: "",
                      placeholder: "",
                      required: false,
                      info: false,
                      character_count: 0,
                      displayOn: "contact",
                      displayOnValue: "true",
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    hr4: {
                      type: "hr",
                      size: "12",
                    },
                  },
                  children: [],
                },
              },
            ],
          },
        ],
      },
    ],
  },
];

export { analyticsresult };
